/* index.js */

// Needed only for the web package manager
